import { Validator } from './Validator';

export type FormErrors = {
	newPassword: string;
	newPasswordConfirm: string;
};

export const initialFormErrors: FormErrors = {
	newPassword: '',
	newPasswordConfirm: '',
};

export const getErrorMessage = <T>(name: string, value: T): string => {
	const validator = new Validator(value);
	switch (name) {
		case 'newPassword':
		case 'newPasswordConfirm':
			return validator.require().charTypePassword().end();
		default:
			return '';
	}
};
